import { jsxs, jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconLlmIdea = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    className: "icon-llm-idea",
    "data-icon": "icon-llm-idea",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: [jsx("path", {
      d: "M8.25 21.75H15.75",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M7.37812 15.6563C6.48653 14.9598 5.76437 14.0703 5.26588 13.0546C4.76739 12.039 4.50554 10.9236 4.49999 9.79219C4.47749 5.72719 7.75499 2.34375 11.8191 2.25C13.3941 2.21185 14.9411 2.67066 16.2406 3.56132C17.5402 4.45198 18.5263 5.72927 19.059 7.21196C19.5916 8.69464 19.6439 10.3074 19.2083 11.8215C18.7727 13.3355 17.8714 14.674 16.6322 15.6469C16.3589 15.8588 16.1374 16.1302 15.9845 16.4404C15.8317 16.7507 15.7515 17.0917 15.75 17.4375V18C15.75 18.1989 15.671 18.3897 15.5303 18.5303C15.3897 18.671 15.1989 18.75 15 18.75H8.99999C8.80108 18.75 8.61032 18.671 8.46966 18.5303C8.32901 18.3897 8.24999 18.1989 8.24999 18V17.4375C8.24963 17.0939 8.17092 16.7548 8.01984 16.4462C7.86876 16.1375 7.64929 15.8673 7.37812 15.6563Z",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M12.75 5.25C14.625 5.56594 16.1822 7.125 16.5 9",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
});
IconLlmIdea.displayName = 'IconLlmIdea';

export { IconLlmIdea };
//# sourceMappingURL=llm-idea.js.map
